module.exports = __webpack_public_path__ + "static/poster@large-30c74ae0793c678143dc0f9f87e1e04f.jpg";